'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$() {
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$ as $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$ as $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$ };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return 85327;
});
$p.b = (function() {
  return "Url";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "Url";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.y = (function(p) {
  return this;
});
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$, "be.doeraene.webcomponents.ui5.configkeys.InputType$Url$", ({
  gB: 1,
  b0: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$ as $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$ };
var $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$;
function $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$)) {
    $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$ = new $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$ as $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Url$ };
